import { render, staticRenderFns } from "./LmPlans.vue?vue&type=template&id=6381a003&"
import script from "./LmPlans.vue?vue&type=script&lang=js&"
export * from "./LmPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports